<script>
    import { preventDefault } from 'svelte/legacy';

import {
    fade
} from 'svelte/transition';
import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    fontState
} from '@app/store/fontStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    authState
} from '@app/store/authStore.svelte.js';
import EventGroup from '@cclib/classes/eventGroup.js';
import LanguageSelect from '@app/components/inputs/LanguageSelect.svelte';
import * as m from '@app/paraglide/messages.js';
let eventGroupType =  $state(eventGroupState[projectState.selected].type),
    displayName = $state(eventGroupState[projectState.selected].name),
    language = $state(eventGroupState[projectState.selected].language),
    linkedGroupId = $state(eventGroupState[projectState.selected].linkedGroup),
    rtl = $state(eventGroupState[projectState.selected].rtl),
    originalRtl = $state(eventGroupState[projectState.selected].originalRtl),
    originalFontFamily = $state(eventGroupState[projectState.selected].originalFontFamily),
    fontFamily = $state(eventGroupState[projectState.selected].fontFamily),
    fontSize = $state(eventGroupState[projectState.selected].fontSize),
    overlap = $state(eventGroupState[projectState.selected].overlap),
    maxCps = $state(eventGroupState[projectState.selected].maxCps),
    maxWpm = $state(eventGroupState[projectState.selected].maxWpm),
    maxChars = $state(eventGroupState[projectState.selected].maxChars),
    maxLines = $state(eventGroupState[projectState.selected].maxLines),
    minDuration = $state(eventGroupState[projectState.selected].minDuration),
    maxDuration = $state(eventGroupState[projectState.selected].maxDuration),
    illegalChars = $state(eventGroupState[projectState.selected].illegalChars);

function updateEventGroup() {
    eventGroupState[projectState.selected].type = eventGroupType || "subtitle";
    eventGroupState[projectState.selected].name = displayName;
    eventGroupState[projectState.selected].language = language;
    eventGroupState[projectState.selected].rtl = rtl;
    eventGroupState[projectState.selected].fontFamily = fontFamily;
    eventGroupState[projectState.selected].fontSize = fontSize || 16;
    eventGroupState[projectState.selected].overlap = overlap,
    eventGroupState[projectState.selected].illegalChars = illegalChars,
    eventGroupState[projectState.selected].maxCps = maxCps || 9999,
    eventGroupState[projectState.selected].maxWpm = maxWpm || 9999,
    eventGroupState[projectState.selected].maxChars = maxChars || 9999,
    eventGroupState[projectState.selected].maxLines = maxLines || 9999,
    eventGroupState[projectState.selected].minDuration = minDuration || 0.0001,
    eventGroupState[projectState.selected].maxDuration = maxDuration || 9999,
    eventGroupState[projectState.selected].originalFontFamily = originalFontFamily;
    eventGroupState[projectState.selected].originalRtl = originalRtl;
    eventGroupState[projectState.selected].linkedGroup = eventGroupType === "translation" ? linkedGroupId : false;

    insertHistoryAction({
        name: "update event group", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    localStorage.setItem("cc-event-group-defaults", JSON.stringify({
        eventGroupType: eventGroupType,
        name: displayName,
        language: language,
        fontFamily: fontFamily,
        fontSize: fontSize || 16,
        overlap : overlap,
        illegalChars : illegalChars,
        maxCps : maxCps || 9999,
        maxWpm : maxWpm || 9999,
        maxChars : maxChars || 9999,
        maxLines : maxLines || 9999,  
        minDuration : minDuration >= 0 ? minDuration : 0.5,
        maxDuration : maxDuration || 9999,
        rtl: rtl
    }));

    hideModal();
}

</script>

<div transition:fade={{duration: 100}} class="modal {modalState.selected === 'editEventGroup' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="editEventGroupTitle"
    aria-describedby="editEventGroupDesc"
    tabindex="-1" 
    id="EditEventGroupModal">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="editEventGroupTitle">{m.edit_event_group_title()}</h4>
                <button type="button" class="btn-close" id="closeEditEventBtn" aria-label={m.close()} onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="editEventGroupDesc" class="visually-hidden">{m.edit_event_group_description()}</p>
                <form onsubmit={preventDefault(updateEventGroup)} id="EditEventGroupForm">
                    <!-- Group Type -->
                    <div class="mb-3">
                        <label class="form-label" for="groupTypeSelect">{m.edit_event_group_type_label()}</label>
                        <select class="form-select" id="groupTypeSelect" bind:value={eventGroupType} aria-describedby="groupTypeHelp">
                            <option value="subtitle">{m.edit_event_group_type_subtitle()}</option>
                            {#if authState.ad}
                            <option value="audio description">{m.edit_event_group_type_audio_description()}</option>
                            {/if}
                            <option value="transcription">{m.edit_event_group_type_transcription()}</option>
                            <option value="translation">{m.edit_event_group_type_translation()}</option>
                        </select>
                        <div id="groupTypeHelp" class="form-text">{m.edit_event_group_type_help()}</div>
                    </div>
                    <!-- Name -->
                    <div class="mb-3">
                        <label class="form-label" for="displayNameInput">{m.edit_event_group_display_name_label()}</label>
                        <input class="form-control" id="displayNameInput" onfocus={(e)=>{e.target.select()}} required 
                            placeholder={m.edit_event_group_display_name_placeholder()} type="text" bind:value={displayName}
                            aria-describedby="displayNameHelp">
                        <div id="displayNameHelp" class="form-text">{m.edit_event_group_display_name_help()}</div>
                    </div>
                    <!-- Language -->
                    <div class="mb-3">
                        <label class="form-label" for="Language">{m.edit_event_group_language_label()}</label>
                        <LanguageSelect id="Language" bind:value={language} />
                    </div>
                    <div class="form-check form-switch mb-2">
                        <input type="checkbox" class="form-check-input" id="rtlSwitch" bind:checked={rtl}>
                        <label class="form-check-label" for="rtlSwitch">{m.edit_event_group_rtl_label()}</label>
                    </div>
                    <div class="row">
                        <!-- Font Family -->
                        <div class="col-6 mb-3">
                            <label class="form-label" for="fontFamilySelect">{m.edit_event_group_font_family_label()}</label>
                            <select class="form-select" id="fontFamilySelect" style="font-family: {fontFamily};" bind:value={fontFamily} aria-describedby="fontFamilyHelp">
                                {#each fontState as font (font.id)}
                                <option style="font-family: {font.name};">{font.name}</option>
                                {/each}
                                <option style="font-family: Arial;">Arial</option>
                                <option style="font-family: Verdana;">Verdana</option>
                                <option style="font-family: Helvetica;">Helvetica</option>
                                <option style="font-family: Tahoma;">Tahoma</option>
                                <option style="font-family: Trebuchet MS;">Trebuchet MS</option>
                                <option style="font-family: Times New Roman;">Times New Roman</option>
                                <option style="font-family: Georgia;">Georgia</option>
                                <option style="font-family: Garamond;">Garamond</option>
                                <option style="font-family: Courier New;">Courier New</option>
                                <option style="font-family: Brush Script MT;">Brush Script MT</option>
                                <option style="font-family: serif;">serif</option>
                                <option style="font-family: sans-serif;">sans-serif</option>
                                <option style="font-family: plexMono;">plexMono</option>
                                <option style="font-family: cursive;">cursive</option>
                                <option style="font-family: fantasy;">fantasy</option>
                            </select>
                        </div>
                        <!-- Font Size -->
                        <div class="col-6 mb-3">
                            <label class="form-label" for="fontSizeInput">{m.edit_event_group_font_size_label()}</label>
                            <input type="number" step="1" min="8" max="72" class="form-control" id="fontSizeInput" bind:value={fontSize} aria-describedby="fontSizeHelp">
                        </div>
                    </div>
                    <div>
                        <hr/>
                        <p class="lead text-warning m-0">{m.edit_event_group_error_detection_heading()}</p>
                        <div class="row">
                            <div class="col-6 mb-3">
                                <label class="form-label" for="Maximum characters per second">{m.edit_event_group_max_cps_label()}</label>
                                <input type="number" step="1" min="0" max="9999" class="form-control" bind:value={maxCps}>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label" for="Maximum words per minute">{m.edit_event_group_max_wpm_label()}</label>
                                <input type="number" step="1" min="0" max="9999" class="form-control" bind:value={maxWpm}>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label" for="Maximum characters per line">{m.edit_event_group_max_chars_label()}</label>
                                <input type="number" step="1" min="0" max="9999" class="form-control" bind:value={maxChars}>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label" for="Maximum lines per event">{m.edit_event_group_max_lines_label()}</label>
                                <input type="number" step="1" min="0" max="9999" class="form-control" bind:value={maxLines}>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label" for="Minimum Event Duration">{m.edit_event_group_min_duration_label()}</label>
                                <input type="number" step="0.01" min="0" max="9999" class="form-control" bind:value={minDuration}>
                            </div>
                            <div class="col-6 mb-3">
                                <label class="form-label" for="Maximum Event Duration">{m.edit_event_group_max_duration_label()}</label>
                                <input type="number" step="0.01" min="0" max="9999" class="form-control" bind:value={maxDuration}>
                            </div>
                            <div class="col-6 mb-3">
                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="overlapCheck" bind:checked={overlap}>
                                    <label class="form-check-label" for="overlapCheck">{m.edit_event_group_overlap_label()}</label>
                                </div>
                            </div>
                            <div class="col-6 mb-3">
                                <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input" id="illegalCharsCheck" bind:checked={illegalChars}>
                                    <label class="form-check-label" for="illegalCharsCheck">{m.edit_event_group_illegal_chars_label()}</label>
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <!-- Linked Group -->
                    {#if eventGroupType === 'translation'}
                    <div transition:fade={{duration: 100 }}>
                        <hr/>
                        <p class="lead text-warning m-0">{m.edit_event_group_translation_options_heading()}</p>
                        <div class="mb-3">
                            <label class="form-label" for="Linked group">{m.edit_event_group_linked_group_label()} <i class="bi bi-info-circle" title={m.edit_event_group_linked_group_tooltip()}></i></label>
                            <select class="form-select bg-light"  bind:value={linkedGroupId} disabled>
                                {#each eventGroupState as eventGroup, index}
                                    <option value={eventGroup.id}>{eventGroup.name}</option>
                                {/each}
                                <option value="none">{m.edit_event_group_none_option()}</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label" for="Original font family">{m.edit_event_group_original_font_family_label()}</label>
                            <select class="form-select" style="font-family: {originalFontFamily};" bind:value={originalFontFamily}>

                                {#each fontState as font (font.id)}
                                <option style="font-family: {font.name};">{font.name}</option>
                                {/each}
                                <option style="font-family: Arial;">Arial</option>
                                <option style="font-family: Verdana;">Verdana</option>
                                <option style="font-family: Helvetica;">Helvetica</option>
                                <option style="font-family: Tahoma;">Tahoma</option>
                                <option style="font-family: Trebuchet MS;">Trebuchet MS</option>
                                <option style="font-family: Times New Roman;">Times New Roman</option>
                                <option style="font-family: Georgia;">Georgia</option>
                                <option style="font-family: Garamond;">Garamond</option>
                                <option style="font-family: Courier New;">Courier New</option>
                                <option style="font-family: Brush Script MT;">Brush Script MT</option>
                                <option style="font-family: serif;">serif</option>
                                <option style="font-family: sans-serif;">sans-serif</option>
                                <option style="font-family: plexMono;">plexMono</option>
                                <option style="font-family: cursive;">cursive</option>
                                <option style="font-family: fantasy;">fantasy</option>
                            </select>
                        </div>
                        <div class="form-check form-switch mb-2">
                            <input type="checkbox" class="form-check-input" id="originalRtlSwitch" bind:checked={originalRtl}>
                            <label class="form-check-label" for="originalRtlSwitch">{m.edit_event_group_rtl_label()}</label>
                        </div>
                    </div>                    
                    {/if}
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" id="updateEventGroupBtn" type="button" onclick={updateEventGroup}>{m.edit_event_group_update_button()}</button>
            </div>
        </div>
    </div>
</div>
